export default {"src":"/_next/static/media/globe-icon.0020db5f.svg","height":20,"width":21};